import React from 'react';
import { PresentIcon } from '../../../shared/SVG/Icons/PresentIcon';
import { Heading } from '../../../shared/Heading/Heading';
import { useTranslations } from '../../../../hooks/useTranslationsHelper';
import './PromotionError.scss';

export interface PromotionErrorProps {
  type?: 'loading' | 'not-found';
}

export const PromotionError = ({ type = 'loading' }: PromotionErrorProps): JSX.Element => {
  const { t } = useTranslations();

  const getErrorMessage = (): string => {
    switch (type) {
      case 'not-found':
        return t('promotions.list-not-found');
      case 'loading':
      default:
        return t('promotions.list-error');
    }
  };

  const errorMessage = getErrorMessage();

  return (
    <div className="promotion-error">
      <PresentIcon />
      <Heading level={4}>{errorMessage}</Heading>
    </div>
  );
};
